import React, { useEffect } from 'react';
import { ReactComponent as StarfinLogo } from '../images/stashfin-logo.svg'
import { ReactComponent as SuccessIcon } from '../images/success-check.svg'
import { useNavigate } from 'react-router-dom';
import PageHeader from '../components/PageHeader';
import { useTapClickMutation } from '../lib/middleware/TapClickApi';
import { pushCleverTapEvent } from "../lib/middleware/CtEvents";
function KycSuccess() {
    const navigate = useNavigate()
    const [tapClick] = useTapClickMutation()
    useEffect(() => {
        setTimeout(() => {
            const event_name = 'web_kyc_success'
            const event_property = { Source: window.localStorage.getItem('utm_source'), segment: localStorage.getItem('customerSegment') }
            pushCleverTapEvent({ event_name, event_property })
            localStorage.setItem("lastVisitedPage", '/verify-bank')
            navigate('/verify-bank')
        }, 1000);
    }, [navigate, tapClick])
    return (
        <div className='external-wrapper'>
            <div className='page-content'>
                <PageHeader />
                <div className="kyc-success">
                    <div className="icon-success">
                        <SuccessIcon />
                    </div>
                    <h2>Success</h2>
                    <p>We have obtained your documents from DigiLocker</p>
                    <p className="note">Redirecting automatically</p>
                </div>
            </div>
            <div className='bottom-footer'>
                <p className='powered-by'>Powered by <StarfinLogo /></p>
            </div>
            {/*<CenteredPopup isOpen={true} icon={<ErrorIcon />} buttons={[{ label: 'Close' }]}>
                <p>We are unable to proceed with your application at the moment. Please try again after some time.</p>
            </CenteredPopup>*/}
        </div>
    );
}

export default KycSuccess;
